// config.js
const ENV = 'prod'; // Change to 'dev' for development

const config = {
  dev: {
    API_URL: 'https://spilve-be.demo-zone.site/',
    ENABLE_REGISTRATION: true,
    SKIP_VERIFICATION: true,
  },
  prod: {
    API_URL: 'https://ppr-be.spilve.org/',
    ENABLE_REGISTRATION: true,
    SKIP_VERIFICATION: false,
  },
};

export const ENV_CONFIG = config[ENV];
export const IS_DEV = ENV === 'dev';
export default ENV;